<template>
  <section class="mt-2">
    <v-dialog persistent v-model="formDialogVisible" max-width="400px">
      <v-card>
        <v-form ref="form" v-model="valid">
          <v-toolbar dark color="secondary font-weight-bold " flat dense>
            <span class="subtitleFontsize">{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn depressed small icon @click="closeFormDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <label class="my-0 rounded labelFontsize required">
                  Payment Mode
                </label>
                <v-autocomplete
                  v-model="paymentModeData.payment_mode"
                  placeholder="Payment Mode"
                  dense
                  outlined
                  class="rounded"
                  :rules="FieldRequired('Payment Mode')"
                  item-text="txt"
                  item-value="val"
                  :items="method_options"
                ></v-autocomplete>
                <label class="my-0 rounded labelFontsize required">
                  Txn Type
                </label>
                <v-autocomplete
                  v-model="paymentModeData.txn_type"
                  placeholder="Txn Type"
                  dense
                  outlined
                  class="rounded"
                  :rules="FieldRequired('Txn Type')"
                  :items="user_types"
                ></v-autocomplete>
                <label class="my-0 rounded labelFontsize required">
                  Min Limit
                </label>
                <v-text-field
                  v-model="paymentModeData.min_txn_limit"
                  dense
                  type="number"
                  hide-spin-buttons
                  outlined
                  placeholder="Min Amount Limit"
                  class="rounded"
                  @keydown="filterNumberInput"
                  :rules="FieldNumbRequired('Min. Amt Limit')"
                >
                </v-text-field>

                <label class="my-0 rounded labelFontsize required">
                  Max Limit
                </label>
                <v-text-field
                  v-model="paymentModeData.max_txn_limit"
                  placeholder="Max Amount Limit"
                  dense
                  type="number"
                  hide-spin-buttons
                  outlined
                  @keydown="filterNumberInput"
                  :rules="FieldNumbRequired('Max. Amt Limit')"
                  class="rounded"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="pa-0 ma-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              depressed
              small
              color="primary"
              class="text-capitalize"
              outlined
              @click="closeFormDialog"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
            </v-btn>
            <v-btn
              depressed
              @click="submit()"
              small
              color="primary"
              class="text-capitalize"
            >
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <template>
      <v-card class="pa-2 mt-3 bord-color" elevation="0" rounded outlined>
        <v-sheet
          class="v-sheet--offset ms-4 pt-1 text-center"
          elevation="0"
          outlined
          width="90px"
        >
          <p class="font-weight-bold">
            <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
            >Filters
          </p>
        </v-sheet>
        <v-form ref="form" v-model="valid" class="px-2">
          <v-row row-gutters class="align-items-center">
            <v-col cols="12" lg="3" md="3" sm="12">
              <v-autocomplete
                class="rounded"
                v-model="searchInputs.txn_type"
                dense
                outlined
                :items="user_types"
                label="Txn Type"
                placeholder="Select User Type"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-btn
                depressed
                small
                class="ms-3 mb-6 primary text-capitalize"
                @click="getAllPaymentModes()"
                >Get Results</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <v-row class="mt-5">
        <v-btn
          depressed
          class="text-capitalize ms-8 me-3"
          small
          color="primary"
          @click="openFormDialog"
        >
          <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
        </v-btn>
        <v-btn depressed @click="downloadExcelsheet" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>

        <v-col cols="12" lg="4" xs="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to filter the table data."
            single-line
            class="me-4 mx-2"
            dense
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <v-data-table
      fixed-header
      height="55vh"
      :headers="headers"
      dense
      :search="search"
      class="p-1"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      :items="paymentModes"
    >
      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-switch
            v-model="item.is_active"
            height="0px"
            color="success"
            dense
            @click="isactiveupdate(item)"
          ></v-switch>
          <v-icon small color="primary" class="mr-2" @click="editItem(item)">
            mdi-content-save-edit-outline
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import partnerService from "@/services/partnerService/partnerService.js";
import setupService from "@/services/SetupService/setupService";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
export default {
  name: "Payment Modes",
  mixins: [alerts],
  data() {
    return {
      user_types: [
        {
          text: "Individual",
          value: "IND",
        },
        {
          text: "Business",
          value: "BUS",
        },
      ],
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      search: "",
      valid: true,
      formDialogVisible: false,
      loader: false,
      dialogDelete: false,
      isLoading: false,
      partnerId: null,
      currencyid: null,
      itemToDelete: null,
      paymentModes: [],
      method_options: [],
      Currencybyid: [],
      appliedfor: [],
      searchInputs: {
        txn_type: "IND",
      },
      paymentModeData: {
        country: "",
        partner: 0,
        txn_type:"",
        payment_mode: "",
        min_txn_limit: 0,
        max_txn_limit: 0,
        limit_currency: "",
        is_realtime: true,
        ex_rate: 0,
      },
      editedIndex: -1,
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Payment Mode",
          value: "payment_mode",
        },
        { text: "Min Amount Limit", value: "min_txn_limit" },
        { text: "Max Amount Limit", value: "max_txn_limit" },
        { text: "Action", value: "actions", sortable: false },
      ],
    };
  },

  components: {
    Loading,
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Payment Mode" : "Edit Payment Mode";
    },
  },
  mounted() {
    this.partnerId = this.$route.query.partner_id;
    console.log("partnerId", this.partnerId);
    localStorage.getItem("companyCountryCode");
    localStorage.getItem("localCurrency");
    this.getAllPaymentModes();
    this.getPaymentModes(localStorage.getItem("companyCountryCode"));
  },
  methods: {
    async downloadExcelsheet() {
      if (this.paymentModes) {
        this.exportToExcel(this.headers, this.paymentModes, "paymentModes");
      }
    },

    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    openFormDialog() {
      this.formDialogVisible = true;
      this.resetPaymentMode();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    resetPaymentMode() {
      this.paymentModeData = {};
      this.paymentModeData.country = localStorage.getItem("companyCountryCode");
      this.paymentModeData.partner = this.partnerId;
      this.paymentModeData.is_realtime = true;
      this.paymentModeData.ex_rate = 0;
      this.paymentModeData.limit_currency =
        localStorage.getItem("localCurrency");
    },
    closeFormDialog() {
      this.formDialogVisible = false;
      this.$refs.form.reset();
    },
    deleteItem(index) {
      this.itemToDeleteIndex = index;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$refs.form.resetValidation();
    },
    async editItem(item) {
      this.formDialogVisible = true;
      console.log(item);
      this.getPaymentModeById(item.id);
    },

    async getAllPaymentModes() {
      this.loader = true;
      try {
        const responseData = await partnerService.getAllPayments(
          this.partnerId,
          this.searchInputs.txn_type
        );
        if (responseData && responseData.data.status_code == 200) {
          this.paymentModes = responseData.data.data.reverse();
          this.loader = false;
        } else {
          this.paymentModes =[]
          this.showAlertError("Failed : " + responseData.data.message);
          this.loader = false;
        }
        console.log("paymentModes", this.paymentModes);
      } catch (e) {
        this.paymentModes =[]
        console.log(e);
        this.loader = false;
      }
    },
    async getPaymentModeById(id) {
      this.loader = true;
      try {
        const responseData = await partnerService.getPaymentById(id);
        if (responseData && responseData.data.status_code == 200) {
          this.paymentModeData = responseData.data.data[0];
          this.loader = false;
        } else {
          this.showAlertError("Failed :  " + responseData.data.message);
          this.loader = false;
        }
        console.log("Payment Mode", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    submit() {
      const validate = this.$refs.form.validate();
      if (validate) {
        if (this.paymentModeData.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },

    async save() {
      try {
        const responseData = await partnerService.addPaymentMode(
          this.paymentModeData
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.formDialogVisible = false;
          this.stoploader();
          this.getAllPaymentModes();
        } else {
          this.showAlertError("Failed: " + responseData.data.message);
          this.loader = false;
        }
        console.log("Saved Data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Failed : Something went wrong");
      }
    },

    async update() {
      try {
        const responseData = await partnerService.updatePaymentMode(
          this.paymentModeData.id,
          this.paymentModeData
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.formDialogVisible = false;
          this.stoploader();
          this.getAllPaymentModes();
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
          this.loader = false;
        }
        console.log("Update Data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Failed : Something went wrong");
      }
    },

    async isactiveupdate(isactive) {
      this.loader = true;
      try {
        const responseData = await partnerService.isactiveStatusPayMode(
          isactive.id,
          isactive.is_active,
          {}
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.stoploader();
          this.getAllPaymentModes();
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    async getPaymentModes(country_code) {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getpaymentmodeBycntry(country_code);
        if (response.data.status_code === 200) {
          this.method_options = [
            ...response.data.data.map((i) => {
              return {
                txt: i.payment_type.payment_mode,
                val: i.payment_type.payment_mode_code,
              };
            }),
          ];
          console.log("countryOptions", this.method_options);
          this.stoploader();
        } else {
          this.method_options == [];
          this.stoploader();
        }
      } catch (error) {
        this.method_options = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>

<style>
.required:after {
  content: " *";
  color: red;
}

.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
</style>
